import { useOutletContext } from 'react-router-dom'

import { Currency } from 'dinero.js'
import {
  ItManagementCardFragment,
  ItManagementExchangeCurrencyFragment,
  ItManagementMonthlySoftwareCost,
  ItManagementSoftwareSetupItemFragment,
} from 'generated/resources/graphql'

export interface ApplicationDetailsRouterOutletContextParams {
  softwareSetup: ItManagementSoftwareSetupItemFragment
  card: ItManagementCardFragment | null | undefined
  canManagePurchaseFinancialDocuments: boolean
  currency: Currency
  softwareCosts: ItManagementMonthlySoftwareCost[]
  currencies: ItManagementExchangeCurrencyFragment[]
}

export const useApplicationDetailsRouterParams = () =>
  useOutletContext<ApplicationDetailsRouterOutletContextParams>()
